import type {BuiltInTrajectoryFormat} from 'molstar/lib/commonjs/mol-plugin-state/formats/trajectory';
import {lazy} from 'react';

import {EXTERNAL_FILE_TYPE, MolstarFileViewer} from 'constants/PreviewTypeConstants';
import suspend from 'util/suspend';

import type {MolstarWrapperProps} from './Viewer';

// separated out from util to allow async import of more of molstar
export const MOLSTAR_PREVIEW_TYPE_TO_FORMAT: Record<MolstarFileViewer, BuiltInTrajectoryFormat> = {
  [EXTERNAL_FILE_TYPE.MOLSTAR_PDB_VIEWER]: 'pdb',
  [EXTERNAL_FILE_TYPE.MOLSTAR_PDBQT_VIEWER]: 'pdbqt',
  [EXTERNAL_FILE_TYPE.MOLSTAR_MMCIF_VIEWER]: 'mmcif',
};

const MolstarViewer = lazy(() => import(/* webpackChunkName: "molstar-viewer" */ './Viewer'));

export default suspend<MolstarWrapperProps>(MolstarViewer);
